var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 67,
    viewBox: "0 0 150 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3248 26.067V32.5196H55.1687V19.7729H46.4263V46.3781H55.1687V37.726H72.3248V46.3781H81.0589V26.067H72.3248Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5502 24.7906H72.3374V19.7729H105.247V24.7906H95.2926V46.3812H86.5543V24.7906H86.5502Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.891 19.7729H142.714L128.893 36.1967C127.744 37.9667 126.412 39.7367 124.9 41.4946L126.699 43.5723H130.637L141.744 30.4205L141.798 46.3781H150L149.891 19.7729ZM107.432 19.7729V43.9866C110.65 41.3666 113.394 38.5852 115.633 35.7702V30.7587L117.623 33.071C118.997 31.0511 120.092 29.0343 120.904 27.0754L114.663 19.776H107.432V19.7729Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5593 33.1075C8.5593 37.1411 13.2011 40.4131 18.9254 40.4131H31.1898V36.2272H18.4092V30.1951H39.7616V46.4543H18.9337C8.47603 46.4543 0 40.4801 0 33.1136C0 25.7472 8.47603 19.7729 18.9337 19.7729H55.1941V25.805H18.9254C13.2011 25.805 8.5593 29.074 8.5593 33.1075Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.069 8.87924C115.151 7.22194 111.308 6.3811 106.633 6.3811C97.0788 6.3811 86.005 9.81147 76.1885 15.6181H63.0581C67.1379 12.5503 71.505 9.89372 76.0094 7.69414C90.4762 1.87835 107.441 2.28354 118.069 8.87924Z",
    fill: "#D3D3D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.693 4.4797C113.361 -2.70092 93.6946 -0.973549 76.0057 7.69073C90.4765 1.87494 107.441 2.28012 118.069 8.87582C118.398 9.07079 118.731 9.281 119.039 9.49731C119.21 9.60089 119.381 9.72275 119.531 9.84156C128.889 16.8942 123.652 32.8915 107.603 45.4583C105.643 46.9968 103.59 48.4287 101.459 49.7509C100.918 50.089 100.372 50.418 99.8185 50.7501C98.4447 51.5544 97.0501 52.3099 95.6346 53.0228C95.5722 53.0533 95.4972 53.0898 95.4306 53.1203C86.8588 57.3885 77.6876 59.8439 69.607 59.8439C64.6113 59.8439 60.5773 58.8904 57.6049 57.0015C55.1028 55.4174 53.4709 53.2726 52.6758 50.7501H43.5503C43.8584 52.1759 44.3496 53.5346 45.0199 54.8172C46.4062 57.5042 48.5751 59.8531 51.5476 61.7419C66.0184 70.9271 94.1317 65.547 114.335 49.7295C134.534 33.9151 139.168 13.6558 124.693 4.4797Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4306 53.1232C94.9519 53.4005 94.4523 53.6716 93.9486 53.9397C79.3653 61.7022 61.7055 63.2407 50.6817 58.4089C46.8599 56.7364 44.2455 53.9275 43.5586 50.7926L43.5503 50.75H52.6758C53.4751 53.2725 55.1028 55.4173 57.6049 57.0014C60.5773 58.8933 64.6113 59.8438 69.607 59.8438C77.6876 59.8469 86.8588 57.3914 95.4306 53.1232Z",
    fill: "#D3D3D3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/ic_logo.d7d177c6f25ecf3dd684369a7a57510b.svg";
export { ForwardRef as ReactComponent };